import z from "zod";

// src/models/classReminderGlobals.ts
/**
* Global class-reminder opt-in per channel, stored on `customer_notification_configuration/{customerId}`.
* Absent keys are treated as false (off) for gating.
*/
const classReminderGlobalsSchema = z.object({
	fcm: z.boolean().optional(),
	sms: z.boolean().optional(),
	/** Account-level opt-in for the daily class-summary SMS digest (separate from per-class SMS reminders). */
	smsDaily: z.boolean().optional()
});
const DEFAULT_CLASS_REMINDER_GLOBALS = {
	fcm: false,
	sms: false,
	smsDaily: false
};
/** Firestore field name on `customer_notification_configuration` documents. */
const CLASS_REMINDER_GLOBALS_FIELD = "classReminderGlobals";
function mergeClassReminderGlobals(raw) {
	const parsed = classReminderGlobalsSchema.safeParse(raw);
	if (!parsed.success) return { ...DEFAULT_CLASS_REMINDER_GLOBALS };
	return {
		fcm: parsed.data.fcm ?? DEFAULT_CLASS_REMINDER_GLOBALS.fcm,
		sms: parsed.data.sms ?? DEFAULT_CLASS_REMINDER_GLOBALS.sms,
		smsDaily: parsed.data.smsDaily ?? DEFAULT_CLASS_REMINDER_GLOBALS.smsDaily
	};
}
/** True only when `classReminderGlobals.fcm` is explicitly `true`. */
function effectiveClassReminderGlobalFcm(doc) {
	return mergeClassReminderGlobals(doc?.[CLASS_REMINDER_GLOBALS_FIELD]).fcm === true;
}
/** True only when `classReminderGlobals.sms` is explicitly `true`. */
function effectiveClassReminderGlobalSms(doc) {
	return mergeClassReminderGlobals(doc?.[CLASS_REMINDER_GLOBALS_FIELD]).sms === true;
}
/** True only when `classReminderGlobals.smsDaily` is explicitly `true`. */
function effectiveClassReminderGlobalSmsDaily(doc) {
	return mergeClassReminderGlobals(doc?.[CLASS_REMINDER_GLOBALS_FIELD]).smsDaily === true;
}

export { CLASS_REMINDER_GLOBALS_FIELD, DEFAULT_CLASS_REMINDER_GLOBALS, classReminderGlobalsSchema, effectiveClassReminderGlobalFcm, effectiveClassReminderGlobalSms, effectiveClassReminderGlobalSmsDaily, mergeClassReminderGlobals };
//# sourceMappingURL=classReminderGlobals.mjs.map